import React, { useState } from 'react'

import {
    Form,
    Input,
    Button,
    message,
    Divider,
    Upload,
} from 'antd';

import {
    CheckOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

import { sys, user } from "../../../../../service";

export default function EnterAuthView() {
    const navigate = useNavigate()
        , [form] = Form.useForm()
        , [fileList, setFileList] = useState([])        // 上传的图片列表
        , [fileList2, setFileList2] = useState([])        // 上传的图片列表
        , { serverUrl } = useSelector(state => state.siteInfo)
        , [preview, setPreview] = useState({            // 图片预览参数
            open: false,
            title: '',
            image: ''
        })


    const onFinish = async () => {
        const value = await form.validateFields()
        const images = fileList2.map(_ => _.path)
        try {
            const data = await user.apiAuth.enterAuth({
                ...value,
                imageUrl: fileList[0]['path'],
                fileUrl: images,
                type: 0
            })
            message.success(data.message)
            setTimeout(() => {
                navigate(-1)
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    }

    // 删除事件
    const onRemove = file => {
        // 根据点击的文件信息从 fileList 中移除该文件
        const updatedFileList = fileList.filter(item => item !== file);

        // 更新 fileList
        setFileList(updatedFileList);
    };

    // 删除事件
    const onRemove2 = file => {
        // 根据点击的文件信息从 fileList 中移除该文件
        const updatedFileList = fileList2.filter(item => item !== file);

        // 更新 fileList
        setFileList2(updatedFileList);
    };

    return (
        <>
            <div style={{ borderLeft: '5px solid #44AFAD', color: '#44AFAD', fontSize: '18px', paddingLeft: '5px' }}>
                <span>企业认证</span>
                <Button type='primary' onClick={() => navigate(-1)} style={{ float: 'right' }}>返回</Button>
            </div>

            <Divider />

            <Form
                form={form}
                layout='vertical'
                name='userauth.form'
                onFinish={onFinish}
                style={{ width: '360px', margin: '50px auto 0' }}
            >
                <Form.Item
                    name='companyName'
                    label='公司名称'
                    rules={[{ required: true, message: '请填写公司名称' }]}
                >
                    <Input placeholder='请填写' />
                </Form.Item>

                <Form.Item
                    name='creditNo'
                    label='统一社会信用代码'
                    rules={[{ required: true, message: '请填写统一社会信用代码' }]}
                >
                    <Input placeholder='请填写' />
                </Form.Item>

                <Form.Item
                    name='legalPerson'
                    label='法人姓名'
                    rules={[{ required: true, message: '请填写法人姓名' }]}
                >
                    <Input placeholder='请填写' />
                </Form.Item>

                <Form.Item
                    name='address'
                    label='企业地址'
                >
                    <Input placeholder='请填写' />
                </Form.Item>

                <Form.Item
                    name='mobile'
                    label='电话'
                >
                    <Input placeholder='请填写' />
                </Form.Item>

                <Form.Item
                    name='imageUrl'
                    hidden={true}
                >
                </Form.Item>

                <Form.Item
                    label="公司展示"
                >
                    <Upload
                        beforeUpload={async file => {
                            // 限制文件类型图片，以后在加视频等
                            const isImage = file.type.startsWith('image/');
                            if (!isImage) {
                                message.error('只能上传图片文件');
                                return false;
                            }

                            // 限制文件大小为20M
                            const fileSizeLimit = 20 * 1024 * 1024; // 20MB in bytes
                            if (file.size > fileSizeLimit) {
                                message.error('文件大小不能超过20MB');
                                return false;
                            }

                            // 上传图片，获取地址
                            const { data: { path } } = await sys.uploadFile(file)
                            setFileList(prevFileList => [
                                ...prevFileList,
                                { ...file, url: serverUrl + path, path },
                            ]);
                            return false
                        }}
                        listType="picture-card"
                        name="file"
                        fileList={fileList}
                        onRemove={onRemove}
                    // onPreview={file => {
                    //     setPreview({
                    //         open: true,
                    //         title: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
                    //         image: file.url
                    //     })
                    // }}
                    >
                        {fileList.length >= 1 ? null : (
                            <div>
                                <PlusOutlined style={{ fontSize: 40, color: '#ccc' }} />
                            </div>
                        )}

                    </Upload>
                </Form.Item>

                <Form.Item
                    label="相关资质认证"
                >
                    <Upload
                        beforeUpload={async file => {
                            // 限制文件类型图片，以后在加视频等
                            const isImage = file.type.startsWith('image/');
                            if (!isImage) {
                                message.error('只能上传图片文件');
                                return false;
                            }

                            // 限制文件大小为20M
                            const fileSizeLimit = 20 * 1024 * 1024; // 20MB in bytes
                            if (file.size > fileSizeLimit) {
                                message.error('文件大小不能超过20MB');
                                return false;
                            }

                            // 上传图片，获取地址
                            const { data: { path } } = await sys.uploadFile(file)
                            setFileList2(prevFileList => [
                                ...prevFileList,
                                { ...file, url: serverUrl + path, path },
                            ]);
                            return false
                        }}
                        listType="picture-card"
                        name="file"
                        fileList={fileList2}
                        onRemove={onRemove2}
                    >
                        {fileList2.length >= 5 ? null : (
                            <div>
                                <PlusOutlined style={{ fontSize: 40, color: '#ccc' }} />
                            </div>
                        )}

                    </Upload>
                </Form.Item>

                <Form.Item>
                    <Button
                        icon={<CheckOutlined />}
                        type='primary'
                        block
                        size='large'
                        style={{ marginTop: '20px' }}
                        htmlType="submit"
                    >提 交</Button>
                </Form.Item>

            </Form>
        </>
    )
}

